export const ROOT_FOLDER = "root";

export const REQUEST_LIBRARY = "REQUEST_LIBRARY";
export const REQUEST_LIBRARY_SUCCESS = `${REQUEST_LIBRARY}_SUCCESS`;

export const SET_ACTIVE_FOLDER = "SET_ACTIVE_FOLDER";
export const SET_ACTIVE_RECORD = "SET_ACTIVE_RECORD";

export const SUBSCRIBE_TO_FOLDER = "SUBSCRIBE_TO_FOLDER";
export const SUBSCRIBE_TO_FOLDER_SUCCESS = `${SUBSCRIBE_TO_FOLDER}_SUCCESS`;
export const SUBSCRIBE_TO_FOLDER_ERROR = `${SUBSCRIBE_TO_FOLDER}_ERROR`;

export const SUBSCRIBE_TO_RECORD = "SUBSCRIBE_TO_RECORD";
export const SUBSCRIBE_TO_RECORD_SUCCESS = `${SUBSCRIBE_TO_RECORD}_SUCCESS`;
export const SUBSCRIBE_TO_RECORD_ERROR = `${SUBSCRIBE_TO_RECORD}_ERROR`;
